// 常量
// sle 2021年6月1日14:36:49
const minheight = innerHeight - 180

export {
  minheight,
}
